import CityLawyerSelectContainer from './components/CityLawyerSelectContainer.vue';
import InitLazyComponent from 'Modules/InitLazyComponent';
import store from 'Stores/store';

const dropdowns = document.querySelectorAll('.city-lawyer-select-widget');
const initLazyComponent = new InitLazyComponent({
  selectors: dropdowns,
  components: { CityLawyerSelectContainer },
  template: '<CityLawyerSelectContainer />',
  store,
});

initLazyComponent.init();
